import React, {Component} from "react";
import "./Input.css";

import Textarea from "./Textarea/Textarea";

export default class Input extends Component
{
	constructor()
	{
		super();
		this.state = {value: ""};

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(event)
	{
		this.setState({value: event.target.value});
	}

	getValue()
	{
		return this.state.value;
	}

	render()
	{
		let inputClass = "input";

		if(this.state.value.length > 0)
			inputClass += " active";

		return (
			<div className="input-container">
				{this.props.multiline
					? <Textarea onChange={this.handleChange} value={this.state.value} spellCheck={false} className={inputClass} />
					: <input onChange={this.handleChange} value={this.state.value} spellCheck={false} className={inputClass} />
				}

				<label className="label">
					{this.props.placeholder}
				</label>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Input/Input.js